import { GradPlanningStepCtrl } from './grad-planning.controller';

export const GradPlanningStepComponent = {
  controller: GradPlanningStepCtrl,
  bindings: {
    nextStep: '&',
    prevStep: '&',
    selectedGradDate: '<',
  },
  template: require('./grad-planning.html'),
};
